<template>
  <div class="container col-10">
    <div class="ContainerRecordatorio">
      <div class="ContainerRecorda">
        <v-icon color="#f88623" x-large>mdi-alert-circle</v-icon>
        <p>
          <span>
            {{ $t('report.label.startMonetization.text') }}
          </span>
        </p>
      </div>
      <div class="correoEnvio">
        <v-text-field
          :label="$t('report.label.sendFile')"
          class="big-label"
          color="secondary"
          v-model="maskEmail"
          readonly
          disabled
        ></v-text-field>
      </div>
    </div>

    <div class="headerReport">
      <div v-if="this.loading" class="text-center">
        <v-progress-circular
          class="mt-auto"
          :size="70"
          :width="7"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
      <v-data-table
        v-else
        :headers="headers"
        :items="monetizacionStartList.previewData"
        :header-props="{ class: 'red-header' }"
        :search="searchTerm"
        :no-data-text="$t('chart.label.notData') || 'No hay datos disponibles'"
        :footer-props="{ 'items-per-page-text': $t('label.rowsPerPage.title') }"
      >
        <!-- Sección superior de la tabla -->
        <template v-slot:top>
          <div style="margin-bottom: 50px; margin-left: 67px">
            <div class="row justify-space-between mx-auto">
              <v-text-field
                :label="$t('label.search.title')"
                :placeholder="$t('label.search.text')"
                append-icon="mdi-magnify"
                dense
                outlined
                class="col-md-5"
                @input="search"
              ></v-text-field>

              <div class="btn">
                <template>
                  <v-btn
                    x-medium
                    large
                    block
                    rounded
                    color="primary"
                    dark
                    v-if="monetizacionStartList.previewData?.length > 0"
                    @click="ActivateDownloadOrSendEmailMonetization"
                  >
                    {{ $t('report.label.startMonetization') }}
                  </v-btn>
                </template>
              </div>
            </div>
          </div>
        </template>

        <template v-slot:[`item.displayName`]="{ item }">
          <span class="custom-font">{{ item.displayName }}</span>
        </template>

        <template v-slot:[`item.emailAddress`]="{ item }">
          <span class="custom-font">{{ item.emailAddress }}</span>
        </template>

        <template v-slot:[`item.identificationNumber`]="{ item }">
          <span class="custom-font">{{ item.identificationNumber }}</span>
        </template>

        <template v-slot:[`item.requestDate`]="{ item }">
          <span class="custom-font">{{ item.requestDate }}</span>
        </template>

        <template v-slot:[`item.amountToMonetize`]="{ item }">
          <span class="custom-font">{{
            formatCurrency(item.amountToMonetize)
          }}</span>
        </template>
      </v-data-table>
      <div class="totalSolicitudesContainer">
        <p class="totalSolicitudes">
          {{ $t('report.label.table.totalRequests') }}:
          {{ monetizacionStartList?.previewData?.length || 0 }}
        </p>
      </div>
    </div>

    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          fixed
          style="bottom: 50px; right: 20px"
          dark
          large
          color="primary"
          v-bind="attrs"
          v-on="on"
          :disabled="!activateButtons"
          @click="handleDownloadOrSendEmail(false)"
        >
          <v-icon dark>mdi-email-outline</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('report.button.sendEmail') }}</span>
    </v-tooltip>

    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          fixed
          style="bottom: 120px; right: 20px"
          dark
          large
          color="primary"
          v-bind="attrs"
          v-on="on"
          :disabled="!activateButtons"
          @click="handleDownloadOrSendEmail(true)"
        >
          <v-icon dark>mdi-download</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('button.download') }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import Swal from "sweetalert2";

import {
  REPORTS_M,
  ACTION_GET_START_MONETIZATIONS,
  ACTION_EMAIL_SEND_MONETIZATION,
  ACTION_GET_DOWLOADER_OR_SEND_EMAIL_MONETIZATIONS,
  ACTION_GET_MONETIZATION_REPORT_JOB_STATUS,
  GET_LOADING_MONETIZATIONS,
  GET_START_LIST_MONETIZATION,
  GET_EMAIL_SEND_MONETIZATION,
  GET_JOB_STATUS,
} from "@/views/reports/store/types/types.js";
import { mapActions, mapGetters } from "vuex";
import i18n from '@/plugins/i18n';

export default {
  name: "detailReportComponent",
  data() {
    return {
      searchTerm: "",
      isDownload: null,
      activateButtons: false,
      processingJob: false,
      jobId: null,
      pollingInterval: null,
    };
  },

  async mounted() {
    await this.getEmailSendMonetization();
    await this.getListStartMonetization();
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t('report.label.table.user'),
          value: "displayName",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: this.$t('label.email.title'),
          value: "emailAddress",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: this.$t('report.label.table.identification'),
          value: "identificationNumber",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: this.$t('report.label.table.requestDate'),
          value: "requestDate",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1 my-custom-font",
        },

        {
          text: this.$t('report.label.table.amountToMonetize'),
          value: "amountToMonetize",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          value: "action",
          sortable: false,
          align: "center",
          //class: "custom-header mdi-pencil text-subtitle-1",
        },
      ];
    },

    ...mapGetters({
      monetizacionStartList: [`${REPORTS_M}${GET_START_LIST_MONETIZATION}`],
      emailSendMonetization: [`${REPORTS_M}${GET_EMAIL_SEND_MONETIZATION}`],
      loading: `${REPORTS_M}${GET_LOADING_MONETIZATIONS}`,
      jobStatus: `${REPORTS_M}${GET_JOB_STATUS}`,
    }),

    maskEmail() {
      if (!this.emailSendMonetization) {
        return "";
      }
      return this.emailSendMonetization;
    },
  },

  methods: {
    search() {
      // Actualiza el término de búsqueda
      this.searchTerm = event.target.value;
    },

    redirectToDownload(link) {
      const downloadUrl = link;
      window.open(downloadUrl.data.payload, "_blank");
    },

    formatCurrency(value) {
      if (!value) return "0"; // Evita mostrar "undefined"
      return new Intl.NumberFormat("es-ES").format(value);
    },

    ActivateDownloadOrSendEmailMonetization() {
      Swal.fire({
        icon: "info",
        title: i18n.t('report.label.activateDownload.title'),
        html: i18n.t('report.label.activateDownload.text'),
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonText: i18n.t('report.button.confirm'),
        confirmButtonColor: "#6E17A5",
        didOpen: () => {
          document.querySelector(".swal2-icon").style.color = "#6E17A5";
          document.querySelector(".swal2-icon").style.borderColor = "#6E17A5";
        },
      });
      this.activateButtons = true;
    },

    async handleDownloadOrSendEmail(isDownload) {
      const response = await this.getDowloadOrSendEmail(isDownload);

      if (isDownload) {
        // Descarga: si responde 202 con jobId, hacer polling y descargar desde linkFile
        if (response.status === 202 && response.jobId) {
          this.jobId = response.jobId;
          this.processingJob = true;

          Swal.fire({
            title: i18n.t('report.label.processing.title') || 'Generando reporte...',
            text: i18n.t('report.label.processing.text') || 'Por favor espera mientras se genera el archivo.',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });

          this.startDownloadPolling();
          return;
        }

        // Descarga directa (200)
        await this.redirectToDownload(response);
        this.activateButtons = false;
        window.location.reload();
        return;
      }

      // Envío por correo: 202 o 200, mismo Swal original
      this.activateButtons = false;
      await Swal.fire({
        text: i18n.t('report.label.handleDownload.title'),
        icon: "success",
        confirmButtonText: i18n.t('button.ok'),
      });
      window.location.reload();
    },

    startDownloadPolling() {
      this.pollingInterval = setInterval(async () => {
        try {
          const resp = await this.getMonetizationReportJobStatus(this.jobId);
          const jobStatus = resp?.data?.payload;

          if (!jobStatus) return;

          if (jobStatus.jobStatus === 2) {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
            this.processingJob = false;

            Swal.close();

            if (jobStatus.linkFile) {
              window.open(jobStatus.linkFile, '_blank');
            }

            this.activateButtons = false;
            window.location.reload();
          } else if (jobStatus.jobStatus === 3) {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
            this.processingJob = false;

            Swal.close();

            await Swal.fire({
              title: i18n.t('report.label.error.title') || 'Error',
              text: jobStatus.errorMessage || i18n.t('report.label.processing.error') || 'Error al generar el reporte',
              icon: "error",
              confirmButtonText: i18n.t('button.ok'),
            });

            this.activateButtons = false;
          }
        } catch (error) {
          clearInterval(this.pollingInterval);
          this.pollingInterval = null;
          this.processingJob = false;

          Swal.close();

          await Swal.fire({
            title: i18n.t('report.label.error.title') || 'Error',
            text: i18n.t('report.label.polling.error') || 'Error al consultar el estado del reporte',
            icon: "error",
            confirmButtonText: i18n.t('button.ok'),
          });

          this.activateButtons = false;
        }
      }, 3000);
    },

    ...mapActions({
      getListStartMonetization: `${REPORTS_M}${ACTION_GET_START_MONETIZATIONS}`,
      getEmailSendMonetization: `${REPORTS_M}${ACTION_EMAIL_SEND_MONETIZATION}`,
      getDowloadOrSendEmail: `${REPORTS_M}${ACTION_GET_DOWLOADER_OR_SEND_EMAIL_MONETIZATIONS}`,
      getMonetizationReportJobStatus: `${REPORTS_M}${ACTION_GET_MONETIZATION_REPORT_JOB_STATUS}`,
    }),
  },
};
</script>

<style lang="css" scoped>
.headerReport {
  display: flex;
  gap: 40px;
  flex-direction: column;
  margin-bottom: 40px;
}

p span {
  color: #6e17a5;
  font-weight: bold;
  font-size: 15px;
}

.custom-font {
  font-size: 20px;
}

.totalSolicitudesContainer {
  position: fixed;
  bottom: 5px;
}

.totalSolicitudes {
  font-weight: bold;
  color: #6e17a5;
  font-size: 23px;
}

.ContainerRecorda {
  background-color: #ff770048;
  width: 92%;
  height: 75px;
  border-radius: 12px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 20px;
  gap: 8px;
  padding-left: 15px;
}

.ContainerRecordatorio {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  margin: 20px 0px;
}

.ContainerRecordatorio p {
  margin-bottom: 0 !important;
}

.correoEnvio {
  align-self: flex-start;
  margin-left: 75px;
}

@media screen and (max-width: 550px) {
  .headerReport {
    margin: 40px 10px;
  }

  p span {
    font-size: 12px;
  }
}
</style>
